import { Handle, Position } from "@xyflow/react";
import { Cog } from "lucide-react";
import { nodeCfg } from "./nodeConfig";

const handleStyle = (color) => ({ width: 9, height: 9, background: "#fff", border: `2px solid ${color}` });

export default function FlowNode({ data, selected }) {
  const cfg = nodeCfg(data.kind);
  const circle = cfg.shape === "circle";
  const isProcess = data.kind === "process";
  const dim = data.dim ? "opacity-20" : "opacity-100";
  const match = data.match ? "ring-4 ring-amber-300" : "";

  if (circle) {
    return (
      <div
        className={`flex h-[112px] w-[112px] flex-col items-center justify-center rounded-full bg-white text-center shadow-sm transition-opacity ${dim} ${match} ${selected ? "ring-2 ring-offset-2" : ""}`}
        style={{ border: `3px solid ${cfg.color}`, boxShadow: selected ? `0 0 0 2px ${cfg.color}` : undefined }}
        data-testid={`flow-node-${data.label || "untitled"}`}
      >
        <Handle type="target" position={Position.Top} style={handleStyle(cfg.color)} />
        <Handle type="target" position={Position.Left} style={handleStyle(cfg.color)} />
        <div className="px-2">
          <div className="text-[9px] font-bold uppercase tracking-wide" style={{ color: cfg.color }}>{cfg.label}</div>
          <div className="mt-0.5 line-clamp-2 text-[11px] font-semibold leading-tight text-slate-800">{data.label || "Untitled"}</div>
          {data.variant && (
            <div className="mt-0.5 line-clamp-1 text-[9px] leading-tight text-slate-500">{data.variant}</div>
          )}
        </div>
        <Handle type="source" position={Position.Bottom} style={handleStyle(cfg.color)} />
        <Handle type="source" position={Position.Right} style={handleStyle(cfg.color)} />
      </div>
    );
  }

  return (
    <div
      className={`min-w-[160px] max-w-[220px] overflow-hidden rounded-lg bg-white shadow-sm transition-opacity ${dim} ${match} ${selected ? "ring-2 ring-offset-1" : ""}`}
      style={{ border: `1.5px solid ${cfg.color}`, boxShadow: selected ? `0 0 0 2px ${cfg.color}` : undefined }}
      data-testid={`flow-node-${data.label || "untitled"}`}
    >
      <Handle type="target" position={Position.Top} style={handleStyle(cfg.color)} />
      <Handle type="target" position={Position.Left} style={handleStyle(cfg.color)} />
      <div className="h-1.5 w-full" style={{ background: cfg.color }} />
      <div className="px-3 py-2">
        <div className="flex items-center gap-1 text-[9px] font-bold uppercase tracking-[0.08em]" style={{ color: cfg.color }}>
          {isProcess && <Cog className="h-3 w-3" />}
          {isProcess ? (data.processType || "Process") : cfg.label}
        </div>
        <div className="mt-0.5 text-sm font-semibold leading-tight text-slate-800">{data.label || "Untitled"}</div>
        {isProcess && (data.machine || data.location) && (
          <div className="mt-1 text-[10px] leading-tight text-slate-500">
            {data.machine}{data.machine && data.location ? " · " : ""}{data.location}
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} style={handleStyle(cfg.color)} />
      <Handle type="source" position={Position.Right} style={handleStyle(cfg.color)} />
    </div>
  );
}
